//@flow
import * as React from 'react';
// $$FlowIssue
import { useState } from 'react';
import { UploadIcon } from './UploadIcon';
import styles from './MediaUploadControl.module.scss';
import { MediaUploadModal } from './MediaUploadModal';
import { Tabs, Tab, TabPanel } from './Tabs';
import { MediaThumbnail } from './';
import classnames from 'classnames';
import { URLUploadControl } from './URLUploadControl';
import { RemoteResource, FileSystemResource } from './ResourceTypes';

export function MediaUploadControl(props: {
  id: string,
  media: Map<string, *>,
  maxItems: number,
  isOpen: boolean,
  onAdd: (Array<FileSystemResource | RemoteResource>) => void,
  onToggle: () => void,
  onUpload: *,
  onDelete: *,
}) {
  const {
    id,
    onAdd,
    media,
    maxItems,
    isOpen,
    onToggle,
    onUpload,
    onDelete,
  } = props;
  const [selectedTab, setSelectedTab] = useState(0);
  const multiple = media.size < maxItems - 1;
  const disabled = media.size >= maxItems;

  function closeModal() {
    onToggle(false);
    setSelectedTab(0);
  }

  function handleAddFiles(files: File[]) {
    onAdd(files.map(f => new FileSystemResource(f)));
  }

  return (
    <React.Fragment>
      {isOpen && (
        <MediaUploadModal
          onClose={closeModal}
          body={
            <Tabs id={id} index={selectedTab} onChange={setSelectedTab}>
              <Tab>Upload</Tab>
              <Tab>URL</Tab>
              <TabPanel>
                <DropZone onChange={handleAddFiles}>
                  <DropZoneUploadIcon
                    style={{ width: 50, height: 50 }}
                    aria-hidden={true}
                  />
                  <p className="mt1 mb3 brandon">
                    Drag and drop your Photo or Video files here <br /> or
                  </p>
                  <input
                    className={styles.fileInput}
                    type="file"
                    accept="image/*,video/*"
                    id={`${id}-file-input`}
                    multiple={multiple}
                    value=""
                    onChange={e => handleAddFiles(Array.from(e.target.files))}
                    disabled={disabled}
                  />
                  <label
                    htmlFor={`${id}-file-input`}
                    className="btn btn--secondary"
                  >
                    Choose File
                  </label>
                </DropZone>
              </TabPanel>
              <TabPanel>
                <URLUploadControl
                  onChange={data => {
                    onAdd([new RemoteResource(data)]);
                  }}
                />
              </TabPanel>
            </Tabs>
          }
          footer={
            <div className="flex flex-column">
              <ul className="list pa0 cf">
                {Array.from(media.entries()).map(([id, item]: [string, *]) => {
                  return (
                    <li key={id} className="mb2 fl">
                      <MediaThumbnail
                        item={item}
                        onUpload={onUpload}
                        onDelete={onDelete}
                      />
                    </li>
                  );
                })}
              </ul>
              <button
                className="btn btn--primary"
                onClick={closeModal}
                type="button"
              >
                Finish
              </button>
            </div>
          }
        />
      )}
      <button
        type="button"
        className={styles.target}
        onClick={() => onToggle(true)}
        disabled={disabled}
        aria-label="Add media to your answer"
      >
        <UploadIcon className={styles.uploadIcon} />
      </button>
    </React.Fragment>
  );
}

const DropZoneUploadIcon = props => (
  <svg viewBox="0 0 69 69" {...props}>
    <g transform="translate(.741 .421)" fill="none" fillRule="evenodd">
      <circle fill="#FFF" cx={34} cy={34} r={34} />
      <path d="M30 37h8v12h-8zm-7-1h22v1H23zm11-16l11 16H23z" fill="#007BC3" />
    </g>
  </svg>
);

function DropZone(props: {
  children: React.Node,
  onChange: (Array<File>) => void,
}) {
  const { children, onChange } = props;
  const [isDragging, setIsDragging] = useState(false);

  function handleDrop(e) {
    e.preventDefault();
    let files;

    if (e.dataTransfer.items) {
      files = Array.from(e.dataTransfer.items)
        .filter(item => item.kind === 'file')
        .map(item => item.getAsFile());
      // Use DataTransferItemList interface to access the file(s)
    } else if (e.dataTransfer.files) {
      files = Array.from(e.dataTransfer.files);
    }

    const mediaRegex = /(image\/|video\/*)/;
    if (Array.isArray(files)) {
      onChange(files.filter(file => mediaRegex.test(file.type)));
    }

    setIsDragging(false);
  }

  function handleDragOver(e) {
    e.preventDefault();
    setIsDragging(true);
  }

  function handleDragEnter(e) {
    setIsDragging(true);
  }

  function handleDragLeave(e) {
    setIsDragging(false);
  }

  return (
    <div
      className={classnames('bg-light-gray tc pa4 br4 b--moon-gray b--dotted', {
        'bg-lightest-blue b--light-blue': isDragging,
      })}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
    >
      {children}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/ContentSection/__future__/MediaUpload/MediaUploadControl.js